import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setMultiSelected,
  setSingleSelected,
} from "../../../../redux/admin/fileManagerSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";

const SectionMain = ({
  IsPropertyShown,
  setIsPropertyShown,
  setPage,
  Page,
  setLimit,
  Pagination,
}) => {
  const { allFiles, isBulkEnable, multiSelected } = useSelector(
    (state) => state.file,
  );
  const dispatch = useDispatch();

  const handleSelect = (item) => {
    if (isBulkEnable) {
      dispatch(setMultiSelected([...multiSelected, item]));
      setIsPropertyShown(false);
    } else {
      dispatch(setSingleSelected(item));
      setIsPropertyShown(true);
    }
  };
  const handleShowmore = (e) => {
    setPage((prev) => prev + 1);
  };
  const handleRemoveSelected = (item) => {
    dispatch(
      setMultiSelected(multiSelected.filter((file) => file.id !== item.id)),
    );
  };
  return (
    <div className="p-5 bg-white border rounded-lg overflow-hidden ">
      <div className=" overflow-y-auto max-h-[700px] scrollbar-hide">
        <div
          className={`grid ${
            IsPropertyShown
              ? "grid-cols-2 lg:grid-cols-5"
              : "grid-cols-2 lg:grid-cols-6"
          } gap-5 auto-rows-auto`}
        >
          {allFiles.length > 0 ? (
            <>
              {allFiles.map((item, index) => {
                const isImage = item.format?.startsWith("image");
                const selectedFiles = multiSelected.find(
                  (file) => file.id === item.id,
                );
                return (
                  <>
                    <div
                      key={index}
                      className={`w-full h-[150px] p-3 bg-slate-100 rounded-lg cursor-pointer overflow-hidden grid-item ${
                        isBulkEnable ? "relative" : ""
                      }`}
                    >
                      {isBulkEnable && (
                        <div
                          onClick={() => handleSelect(item)}
                          className={`absolute top-0 left-0 w-full h-[150px] ${
                            selectedFiles ? "bg-slate-100/0" : "bg-slate-100/50"
                          } `}
                        ></div>
                      )}
                      {selectedFiles && (
                        <div
                          onClick={() => handleRemoveSelected(item)}
                          className={`absolute top-2 right-2 h-5 w-5 bg-red-500 text-white text-xs flex justify-center items-center rounded-full cursor-pointer hover:bg-red-600 duration-300`}
                        >
                          x
                        </div>
                      )}
                      {isImage ? (
                        <LazyLoadImage
                          onClick={() => handleSelect(item)}
                          alt={item.fileName}
                          className="w-full h-full object-cover rounded-lg"
                          src={item.fileLink.small}
                          placeholderSrc={item.fileLink.small}
                          effect="blur"
                          width="100%"
                          height="100%"
                          visibleByDefault={true}
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-white rounded-lg">
                          <a
                            href={item.fileLink.original}
                            target="_blank"
                            rel="noreferrer"
                            className="text-sm font-medium text-blue-600 underline"
                          >
                            {item.fileName}
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                );
              })}
              {Pagination.total !== allFiles.length && (
                <button
                  onClick={handleShowmore}
                  className="w-full h-[150px] p-3 bg-blue-100 hover:bg-blue-200 font-bold uppercase duration-300 rounded-lg cursor-pointer"
                >
                  {Pagination.total - allFiles.length} more
                </button>
              )}
            </>
          ) : (
            Array.from({ length: 12 }).map((_, index) => (
              <div
                key={index}
                className="bg-slate-200 animate-pulse w-full h-[150px] rounded-lg"
              ></div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionMain;
